import { render, staticRenderFns } from "./splitedView.vue?vue&type=template&id=6b9087a0"
import script from "./splitedView.vue?vue&type=script&lang=js"
export * from "./splitedView.vue?vue&type=script&lang=js"
import style0 from "./splitedView.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports